import { AnemoclinographT } from "./AnemoclinographT";
import { CableT } from "./CableT";
import { DeviceComponentT } from "./DeviceComponentT";
import { DvrT } from "./DvrT";
import { FluviographT } from "./FluviographT";
import { MonitorT } from "./MonitorT";
import { SerialT } from "./SerialT";

export const ModelsInDevice = {
	'AnemoclinographT': AnemoclinographT,
	'DeviceComponentT': DeviceComponentT,
	'FluviographT': FluviographT,
	'MonitorT': MonitorT,
	'SerialT': SerialT,
	'DvrT': DvrT,
	'CableT': CableT,
};